<form #loginForm="ngForm" [ngClass]="{'cspinner load1': this.showLoader}">
  <input autocomplete="false" name="hidden" type="text" style="display:none;">
  <div class="container-fluid">
    <div class="mt-4">
      <div class="headinghead">
        <div class="heading">
          <h1>Admin Fee</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="iq-card">
            <div class="iq-card-body">
              <div class="row">
                <div class="form-group col-md-4">
                  <label for="fname">Fee Type</label>
                  <select class="form-control" [(ngModel)]="insertAdminDTO.feeType" id="discountType"
                    name="discountType" #discountType="ngModel" required placeholder="Coupon Type:">
                    <option value="percentage">Percentage</option>
                    <option value="flat">Flat</option>
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <label for="lname">Fee Value</label>
                  <input type="number" class="form-control" [(ngModel)]="insertAdminDTO.feeValue"
                    id="discountValue" name="discountValue" #discountValue="ngModel" required
                    placeholder="Discount Value:">
                  <span *ngIf="discountValue.invalid && loginForm.submitted">
                    <p class="error" color="danger">*Fee Value is required</p>
                  </span>
                </div>
                <div class="submit-button">
                <button (click)="submitForm(loginForm)">submit</button>
              </div>
                <!-- <div class="form-group col-md-4">
                  <label for="isAlwaysValid">Fee Valid</label>
                  <div class="custom-control custom-switch custom-switch-color custom-control-inline">
                    <input type="checkbox" [(ngModel)]="insertAdminDTO.isAlwaysValid" (change)="changeDecision(insertAdminDTO)" class="custom-control-input bg-waring" id="customSwitch04" name="customSwitch04" checked="">
                    <label class="custom-control-label" for="customSwitch04"></label>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-sm-6">
          <div class="iq-card">
            <div class="iq-card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="headingcreat">
                    <h4>Date:</h4>
                  </div>
                </div>
                <div class="form-group col-md-6" [class.disabledinfoDv]="!insertAdminDTO.isAlwaysValid">
                  <input class="form-control" [(ngModel)]="insertAdminDTO.startDate" name="startTime" type="date"
                    placeholder="Start Time" displayFormat="DD/MM/YYYY" pickerFormat="DD MM YYYY" id="startTime"
                    #startTime="ngModel" required>
                  <span *ngIf="startTime.invalid && loginForm.submitted">
                    <p class="error" color="danger">*Start Date is required</p>
                  </span>
                </div>
                <div class="form-group col-md-6" [class.disabledinfoDv]="!insertAdminDTO.isAlwaysValid">
                  <input class="form-control" [(ngModel)]="insertAdminDTO.endDate" name="endTime" type="date"
                    placeholder="End Time" displayFormat="DD/MM/YYYY" pickerFormat="DD MM YYYY" id="endTime"
                    #endTime="ngModel" required>
                  <span *ngIf="endTime.invalid && loginForm.submitted">
                    <p class="error" color="danger">*End Date is required</p>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="exportbtn buttonInfoDv">
              <a (click)="submitForm(loginForm)">Submit</a>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</form>
